import { ReactNode } from 'react';
import styled from 'styled-components';
import { colors, s16 } from '@ardoq/design-tokens';
import {
  BUTTON_GROUP_SELECTOR,
  ButtonGroup,
  DangerButton,
  PrimaryButton,
} from '@ardoq/button';

const SidebarMenuFooterHint = styled.div`
  align-self: center;
`;

const SidebarMenuFooterError = styled(SidebarMenuFooterHint)`
  color: ${colors.red800};
`;

const SidebarMenuFooterContainer = styled.div`
  border-top: 1px solid ${colors.borderSubtle};
`;

const SidebarMenuFooterStyle = styled.div`
  justify-content: space-between;
  display: flex;
  ${BUTTON_GROUP_SELECTOR}, ${SidebarMenuFooterHint} {
    margin: ${s16};
  }
`;

export type SidebarMenuFooterProps = {
  primaryButtonLabel?: string;
  primaryButtonClickId?: string;
  isPrimaryButtonDisabled?: boolean;
  dangerButtonLabel?: string;
  dangerButtonClickId?: string;
  isDangerButtonDisabled?: boolean;
  hintMessage?: string;
  errorMessage?: string | null;
  footerContent?: ReactNode;
  onPrimaryButtonClick?: () => void;
  onDangerButtonClick?: () => void;
};

export const SidebarMenuFooter = ({
  primaryButtonLabel,
  primaryButtonClickId,
  isPrimaryButtonDisabled,
  dangerButtonLabel,
  dangerButtonClickId,
  isDangerButtonDisabled,
  hintMessage,
  errorMessage,
  footerContent,
  onPrimaryButtonClick,
  onDangerButtonClick,
}: SidebarMenuFooterProps) => {
  return (
    <SidebarMenuFooterContainer>
      {footerContent}
      {(primaryButtonLabel ||
        dangerButtonLabel ||
        hintMessage ||
        errorMessage) && (
        <SidebarMenuFooterStyle>
          <ButtonGroup>
            {primaryButtonLabel && (
              <PrimaryButton
                data-click-id={primaryButtonClickId}
                isDisabled={isPrimaryButtonDisabled}
                onClick={event => {
                  event.preventDefault();
                  onPrimaryButtonClick?.();
                }}
                type="submit"
              >
                {primaryButtonLabel}
              </PrimaryButton>
            )}
            {dangerButtonLabel && (
              <DangerButton
                data-click-id={dangerButtonClickId}
                isDisabled={isDangerButtonDisabled}
                onClick={() => onDangerButtonClick?.()}
              >
                {dangerButtonLabel}
              </DangerButton>
            )}
          </ButtonGroup>
          {hintMessage && (
            <SidebarMenuFooterHint>{hintMessage}</SidebarMenuFooterHint>
          )}
          {errorMessage && (
            <SidebarMenuFooterError>{errorMessage}</SidebarMenuFooterError>
          )}
        </SidebarMenuFooterStyle>
      )}
    </SidebarMenuFooterContainer>
  );
};
